export default function ChecklistsPage() {
  return (
    <div>
      <h1>Checklisten</h1>
      <p>Hier kannst du deine Checklisten verwalten.</p>
    </div>
  );
}
